import { createSlice } from '@reduxjs/toolkit';

import { clearSignupErrors } from '@/redux/modules/account/createAccount/clearSignupErrors.action';
import { submitCreateAccount } from '@/redux/modules/account/createAccount/createAccount.actions';
import { defaultCreateAccountSlice } from '@/redux/modules/account/createAccount/createAccount.types';

const createAccountSlice = createSlice({
    extraReducers: (builder) => {
        builder.addCase(submitCreateAccount.pending, (slice) => {
            slice.error = null;
            slice.submitted = true;
            slice.success = false;
        });
        builder.addCase(submitCreateAccount.fulfilled, (slice) => {
            slice.error = null;
            slice.submitted = false;
            slice.success = true;
        });
        builder.addCase(submitCreateAccount.rejected, (slice, { payload }) => {
            slice.error = payload;
            slice.submitted = false;
            slice.success = false;
        });

        builder.addCase(clearSignupErrors, (slice) => {
            slice.error = null;
        });
    },
    initialState: defaultCreateAccountSlice,
    name: 'createAccount',
    reducers: {},
});

export const { reducer: createAccountReducer } = createAccountSlice;
